<div
  mdbModal
  #modal="mdbModal"
  class="modal fade top lower-modal"
  id="frameModalTop"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body" [ngSwitch]="acceptedJobStep">
        <ng-container *ngSwitchCase="acceptedJobSteps.DEFAULT">
          <div class="p-4">
            <div class="header">{{ Localization.AcceptingJob | translate }}</div>
            <div>{{ Localization.AcceptingJobDateDescription | translate }}</div>
            <br/>
            <div class="mb-4">
                <div class="form-check" (change)="changeDate($event.target.value)">
                    <input type="radio" class="form-check-input" id="today" name="accept-modal" [value]="jobDueDates.TODAY" checked>
                    <label class="form-check-label" for="today">{{ Localization.Today | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="tomorrow" name="accept-modal" [value]="jobDueDates.TOMORROW">
                    <label class="form-check-label" for="tomorrow">{{ Localization.Tomorrow | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="thisWeek" name="accept-modal" [value]="jobDueDates.THISWEEK">
                    <label class="form-check-label" for="thisWeek">{{ Localization.ThisWeek | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="nextWeek" name="accept-modal" [value]="jobDueDates.NEXTWEEK">
                    <label class="form-check-label" for="nextWeek">{{ Localization.NextWeek | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="specificDate" name="accept-modal" [value]="jobDueDates.SPECIFICDATE">
                    <label class="form-check-label" for="specificDate">{{ Localization.SpecificDate | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="noDate" name="accept-modal" [value]="jobDueDates.NODATE">
                    <label class="form-check-label" for="noDate">{{ Localization.NoDate | translate }}</label>
                </div>
            </div>
            <div class="modal-footer justify-content-between orange-text">
              <div (click)="hide()">{{ Localization.Back | translate }}</div>
              <div (click)="next()">{{ Localization.Next | translate }}</div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="acceptedJobSteps.DATE">
          <div>
             <mat-calendar [selected]="scheduledOn" (selectedChange)="onSelect($event)"></mat-calendar>
             <div class="modal-footer justify-content-between orange-text">
              <div (click)="hide()">{{ Localization.Back | translate }}</div>
              <div (click)="next()">{{ Localization.Next | translate }}</div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="acceptedJobSteps.TIME">
          <div class="p-4">
            <div class="header">{{ Localization.AcceptingJob | translate }}</div>
            <div>{{ Localization.AcceptingJobTimeDescription | translate }} {{ scheduledOn | date }}</div>
            <br/>
            <div class="mb-4">
                <div class="form-check" (change)="changeTime($event.target.value)">
                    <!--<input type="radio" class="form-check-input" id="AM" name="accept-modal" [value]="jobTimes.AM" checked>
                    <label class="form-check-label" for="AM">{{ Localization.InAM | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="PM" name="accept-modal" [value]="jobTimes.PM">
                    <label class="form-check-label" for="PM">{{ Localization.InPM | translate }}</label><br/>-->
                    <input type="radio" class="form-check-input" id="morning" name="accept-modal" [value]="jobTimes.MORNING">
                    <label class="form-check-label" for="morning">{{ Localization.FirstThingMorning | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="endOfDay" name="accept-modal" [value]="jobTimes.ENDOFDAY">
                    <label class="form-check-label" for="endOfDay">{{ Localization.BeforeEndOfDay | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="specificTime" name="accept-modal" [value]="jobTimes.SPECIFICTIME">
                    <label class="form-check-label" for="specificTime">{{ Localization.SpecificTime | translate }}</label><br/>
                    <input type="radio" class="form-check-input" id="noTime" name="accept-modal" [value]="jobTimes.NOTIME">
                    <label class="form-check-label" for="noTime">{{ Localization.NoTime | translate }}</label>
                </div>
                <div class="modal-footer justify-content-between orange-text">
                  <div (click)="hide()">{{ Localization.Back | translate }}</div>
                  <div (click)="accept()">{{ Localization.Accept | translate }}</div>
                </div>
            </div>
          </div>
        </ng-container>
      </div>
  </div>
</div>
